/* WEAR POLO — scripts propios (un solo archivo, ejecución única) */
(function () {
  if (window.__wpInit) return;
  window.__wpInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.remove('wp-sin-js');

  /* ---------- Reveals ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('wp-visible'); io.unobserve(e.target); terminar(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' }) : null;

  /* Tras la entrada por palabras se quita el recorte, para que no se corten colas (g, p, y) */
  function terminar(el) {
    if (!el.classList.contains('wp-words')) return;
    var n = el.querySelectorAll('.wp-word').length;
    setTimeout(function () { el.classList.add('wp-hecho'); }, 1300 + n * 70);
  }
  function observar(el) {
    if (!io || reduce) { el.classList.add('wp-visible'); el.classList.add('wp-hecho'); return; }
    io.observe(el);
  }

  /* Parte un titular en palabras respetando <em>, <br> y spans */
  function partirPalabras(el) {
    if (el.dataset.wpWords) return;
    el.dataset.wpWords = '1';
    var i = 0;
    function envolver(nodo) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var partes = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          partes.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'wp-word';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName === 'EM') {
          var w2 = document.createElement('span'); w2.className = 'wp-word';
          var s2 = document.createElement('span'); s2.style.setProperty('--i', i++);
          n.parentNode.replaceChild(w2, n); s2.appendChild(n); w2.appendChild(s2);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') {
          envolver(n);
        }
      });
    }
    envolver(el);
  }

  function initReveals(root) {
    (root || document).querySelectorAll('[data-wp-words]:not([data-wp-words="1"])').forEach(function (el) {
      partirPalabras(el);
    });
    (root || document).querySelectorAll('.wp-reveal, [data-wp-reveal], .wp-words').forEach(function (el) {
      if (el.dataset.wpObs) return; el.dataset.wpObs = '1'; observar(el);
    });
    (root || document).querySelectorAll('.wp-sub').forEach(function (el, k) { el.style.setProperty('--i', k); });
  }

  /* ---------- Marquesina: duplica hasta cubrir 2 anchos ---------- */
  function initMarquesinas(root) {
    (root || document).querySelectorAll('[data-wp-marquesina]').forEach(function (m) {
      if (m.dataset.wpInit) return; m.dataset.wpInit = '1';
      var pista = m.querySelector('.wp-sellos__pista');
      if (!pista) return;
      var base = pista.innerHTML;
      var guard = 0;
      while (pista.scrollWidth < window.innerWidth * 1.2 && guard++ < 12) pista.insertAdjacentHTML('beforeend', base);
      var copia = pista.cloneNode(true); copia.setAttribute('aria-hidden', 'true');
      m.appendChild(copia);
    });
  }

  /* ---------- Producto: variantes ---------- */
  function formatear(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, window.wpMoneyFormat);
    } catch (e) {}
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var loc = document.documentElement.lang || 'es';
    return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-wp-producto]').forEach(function (sec) {
      if (sec.dataset.wpInit) return; sec.dataset.wpInit = '1';
      var dataEl = sec.querySelector('[data-wp-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = sec.querySelector('form[data-type="add-to-cart-form"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = sec.querySelector('.product-form__submit');
      var botonTxt = boton ? boton.querySelector('span') : null;
      var precioEl = sec.querySelector('[data-wp-precio]');
      var tachadoEl = sec.querySelector('[data-wp-tachado]');
      var barraPrecio = sec.querySelector('[data-wp-barra-precio]');
      var fieldsets = sec.querySelectorAll('.wp-opcion');
      var txtAnadir = boton ? boton.dataset.anadir : '';
      var txtAgotado = boton ? boton.dataset.agotado : '';
      var txtNoDisp = boton ? boton.dataset.nodisp : '';

      function seleccion() {
        var sel = [];
        fieldsets.forEach(function (fs) {
          var r = fs.querySelector('input:checked');
          sel[+fs.dataset.opcion] = r ? r.value : null;
        });
        return sel;
      }
      function buscar(sel) {
        return variantes.find(function (v) { return v.options.every(function (o, k) { return sel[k] == null || o === sel[k]; }); });
      }
      function marcarAgotados(sel) {
        fieldsets.forEach(function (fs) {
          var k = +fs.dataset.opcion;
          fs.querySelectorAll('.wp-valor').forEach(function (lab) {
            var val = lab.querySelector('input').value;
            var prueba = sel.slice(); prueba[k] = val;
            var v = variantes.find(function (x) { return x.options.every(function (o, j) { return prueba[j] == null || o === prueba[j]; }); });
            lab.classList.toggle('wp-valor--agotado', !v || !v.available);
          });
          var r = fs.querySelector('input:checked');
          var out = fs.querySelector('[data-wp-valor-sel]');
          if (out) out.textContent = r ? r.value : '';
        });
      }
      function irAFoto(v) {
        if (!v || !v.featured_media) return;
        var item = sec.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        var gal = sec.querySelector('.wp-galeria');
        if (!item || !gal) return;
        sec.querySelectorAll('.wp-galeria__item--activo').forEach(function (x) { x.classList.remove('wp-galeria__item--activo'); });
        if (window.innerWidth < 990) {
          gal.scrollTo({ left: item.offsetLeft - gal.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        } else {
          var primera = gal.firstElementChild;
          if (primera && item !== primera) {
            var img = item.querySelector('img'); var img0 = primera.querySelector('img');
            if (img && img0) {
              if (!img0.dataset.orig) { img0.dataset.orig = img0.getAttribute('src'); img0.dataset.origSet = img0.getAttribute('srcset') || ''; }
              img0.setAttribute('src', img.getAttribute('src'));
              img0.setAttribute('srcset', img.getAttribute('srcset') || '');
            }
          }
          var rect = gal.getBoundingClientRect();
          if (rect.top < 0) window.scrollTo({ top: window.scrollY + rect.top - 120, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function actualizar(moverFoto) {
        var sel = seleccion();
        var v = buscar(sel);
        marcarAgotados(sel);
        if (!v) {
          if (boton) { boton.disabled = true; if (botonTxt) botonTxt.textContent = txtNoDisp; }
          return;
        }
        if (inputId) { inputId.value = v.id; inputId.disabled = false; inputId.dispatchEvent(new Event('change', { bubbles: true })); }
        if (precioEl) precioEl.textContent = formatear(v.price);
        if (barraPrecio) barraPrecio.textContent = formatear(v.price);
        if (tachadoEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachadoEl.textContent = formatear(v.compare_at_price); tachadoEl.hidden = false; }
          else tachadoEl.hidden = true;
        }
        if (boton) { boton.disabled = !v.available; if (botonTxt) botonTxt.textContent = v.available ? txtAnadir : txtAgotado; }
        if (moverFoto) irAFoto(v);
        try {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      fieldsets.forEach(function (fs) {
        fs.addEventListener('change', function (e) { actualizar(fs.dataset.color === '1'); });
      });
      if (fieldsets.length) actualizar(false);

      /* Guía de tallas */
      var dlg = sec.querySelector('[data-wp-dialogo-tallas]');
      sec.querySelectorAll('[data-wp-abrir-tallas]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); if (dlg && dlg.showModal) dlg.showModal(); });
      });
      if (dlg) {
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-wp-cerrar]')) dlg.close(); });
      }

      /* Lightbox */
      var lb = sec.querySelector('[data-wp-lightbox]');
      if (lb) {
        var lbImg = lb.querySelector('img');
        sec.querySelectorAll('[data-wp-zoom]').forEach(function (b) {
          b.addEventListener('click', function () { lbImg.src = b.dataset.wpZoom; if (lb.showModal) lb.showModal(); });
        });
        lb.addEventListener('click', function () { lb.close(); });
      }

      /* Puntos de la galería en móvil */
      var gal = sec.querySelector('.wp-galeria');
      var dots = sec.querySelectorAll('.wp-galeria__dots span');
      if (gal && dots.length) {
        gal.addEventListener('scroll', function () {
          var k = Math.round(gal.scrollLeft / gal.clientWidth);
          dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
        }, { passive: true });
      }

      /* Barra fija móvil */
      var barra = sec.querySelector('[data-wp-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) { barra.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0); });
        }).observe(boton);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          if (boton.disabled) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          boton.click();
        });
      }
    });
  }

  /* ---------- Orden en la página de colección ---------- */
  function initOrden(root) {
    (root || document).querySelectorAll('[data-wp-orden]').forEach(function (s) {
      if (s.dataset.wpInit) return; s.dataset.wpInit = '1';
      s.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Texto gigante que ocupa exactamente el ancho disponible ---------- */
  function ajustarTextos() {
    document.querySelectorAll('[data-wp-ajustar]').forEach(function (el) {
      var padre = el.parentElement;
      var cs = getComputedStyle(padre);
      var disponible = padre.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (!disponible) return;
      el.style.display = 'inline-block';
      var f = parseFloat(getComputedStyle(el).fontSize);
      var w = el.scrollWidth;
      if (w > 0) el.style.fontSize = (f * disponible * 0.995 / w) + 'px';
      el.style.display = 'block';
    });
  }
  var tAjuste;
  window.addEventListener('resize', function () { clearTimeout(tAjuste); tAjuste = setTimeout(ajustarTextos, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustarTextos);
  window.addEventListener('load', ajustarTextos);

  /* Cuenta atrás: <span data-wp-cuenta="2026-10-31 20:00" data-wp-fin="Ya disponibles"> */
  function initCuentas(root) {
    (root || document).querySelectorAll('[data-wp-cuenta]').forEach(function (el) {
      if (el._wpCuenta) return;
      var t = Date.parse(el.getAttribute('data-wp-cuenta').trim().replace(' ', 'T'));
      if (isNaN(t)) return;
      el._wpCuenta = true;
      var fin = el.getAttribute('data-wp-fin') || '';
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      var iv;
      function pinta() {
        var d = t - Date.now();
        if (d <= 0) { el.textContent = fin; clearInterval(iv); return; }
        var x = Math.floor(d / 1000);
        el.textContent = Math.floor(x / 86400) + 'd ' + dos(Math.floor(x % 86400 / 3600)) + 'h ' + dos(Math.floor(x % 3600 / 60)) + 'm ' + dos(x % 60) + 's';
      }
      pinta();
      iv = setInterval(pinta, 1000);
    });
  }

  function initTodo(root) {
    initReveals(root); initMarquesinas(root); initProducto(root); initOrden(root); initCuentas(root); ajustarTextos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
